import { render, staticRenderFns } from "./addTeamDialog.vue?vue&type=template&id=09ffd540&scoped=true"
import script from "./addTeamDialog.vue?vue&type=script&lang=js"
export * from "./addTeamDialog.vue?vue&type=script&lang=js"
import style0 from "./addTeamDialog.vue?vue&type=style&index=0&id=09ffd540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ffd540",
  null
  
)

export default component.exports